export default {
  "common": {
    "all": "全部",
    "cancel": "取消",
    "userAgreement": "用戶協議",
    "close": "關閉",
    "submit": "提交",
    "submitting": "提交中...",
    "report": "举报",
    "loading": "載入中...",
    "noMore": "沒有更多內容了",
    "search": "搜索",
    "today": "今天",
    "collapse": "收起",
    "retryLater": "请稍后重试",
    "retry": "重試",
    "reset": "重置",
    "confirm": "確認",
    "tips": "提示",
    "continue": "繼續",
    "notAvailableYet": "暫未開放",
    "friendlyReminder": "溫馨提示",
    "finish": "完成",
    "noData": "暫無相關數據",
  },
  "tab": {
    "home": "首頁",
    "card": "卡片",
    "mine": "我的"
  },
  "auth": {
    "loginTitle": "一站式Web3支付钱包",
    "loginSubtitle": "一卡连接资产与消费，轻松开启全球支付体验",
    "createWallet": "創建錢包",
    "importWallet": "我已有錢包",
    "choiceOneWay": "选择一种方式，快速开启安全的数字资产之旅",
    "iHaveWallet": "我已有錢包",
    "choiceOneWay2": "选择一种登录方式，快速开启安全的数字资产之旅",
    "createUseEmail": "使用郵箱創建",
    "createUseRemWord": "創建助記詞錢包",
    "loginUseEmail": "使用郵箱登入",
    "loginByReWord": "私鑰 / 助記詞 導入",
    "validByEmail": "通過郵箱快速驗證，簡單便捷",
    "validByReWord": "由助記詞完全掌握，安全且去中心化",
    "validByReWord2": "使用助記詞/私鑰/錢包地址導入",
    "emailLoginRegister": "邮箱登录/注册",
    "inviteRegisterTitleStart": "一觸即付，",
    "inviteRegisterTitleEnd": "輕鬆完成",
    "inviteRegisterStartRewards": "開啟獎勵",
    "inviteRegisterWelcome": "歡迎加入 WinPay！",
    "agreePrefix": "继续使用，代表你同意 WinPay Wallet 的",
    "privacyPolicy": "隐私政策",
    "and": "和",
    "userAgreement": "用戶協議",
    "agreementMessage": "请先阅读用户隐私协议，点击继续表明您同意 WinPay Wallet 的隐私政策和用户协议",
    "agreementConfirm": "已閱讀並同意",
    "addEmailAddress": "添加郵箱地址",
    "inputEmailAddress": "輸入郵箱地址",
    "emailAccountTip": "此郵箱地址將成為您的登入帳號，也是您使用全部服務的關鍵。",
    "emailAddress": "郵箱地址",
    "email": "郵箱",
    "emailLogin": "郵箱登入",
    "enterEmail": "請輸入郵箱",
    "enterEmailAddress": "请输入邮箱地址",
    "register": "註冊",
    "login": "登錄",
    "enterVerificationCode": "輸入驗證碼",
    "codeSentTo": "验证码已发送至 ",
    "codeSentToEmail": "驗證碼已發送至您的電子郵箱：",
    "codeValid": "，有效期10分鐘",
    "emailCode": "電子郵件驗證碼",
    "enterEmailCode": "请输入邮箱验证码",
    "getCode": "獲取驗證碼",
    "resend": "重新發送",
    "codeSent": "已發送驗證碼",
    "codeSentValid": "*验证码已发送，10 分钟内有效",
    "cannotReceiveCode": "收不到驗證碼？",
    "checkSpamFolder": "請檢查垃圾郵件資料夾",
    "codeHelpTitle": "收不到驗證碼？",
    "codeHelpIntro": "驗證碼通常會在1分鐘內送達，如果您還沒收到：",
    "codeHelpEmailTitle": "檢查電郵地址是否正確",
    "codeHelpEmailDesc": "請確認驗證碼已發送到您預期的電郵地址，一個小小的拼寫錯誤，是最常見的未送達原因。",
    "codeHelpSpamTitle": "檢查垃圾郵件資料夾",
    "codeHelpSpamDesc": "驗證郵件有時會被標記為「垃圾郵件」，請確認並改為「非垃圾郵件」，有助於後續驗證碼送達您的收件匣。",
    "codeHelpResendTitle": "再次申請新驗證碼",
    "codeHelpResendDesc": "請務必使用最新的驗證碼，因為舊驗證碼會失效。",
    "verify": "驗證",
    "inputPassword": "輸入密碼",
    "setWalletPassword": "設定錢包密碼",
    "walletPasswordTip": "设置密码用于管理你的钱包。此密码无法恢复，如果你忘记密码，可进入我的主页面-安全设置-找回密码，或者使用邮箱登录重新进入，重设您的支付密码!",
    "setPasswordForTransaction": "請設定錢包密碼，主要用於交易驗證。",
    "strongPassword": "請輸入一個強密碼",
    "enterPasswordPlaceholder": "請輸入密碼",
    "enterPassword": "請輸入",
    "confirmPassword": "請再次輸入密碼",
    "passwordTooShort": "*密码太短，至少需要8个字符。",
    "passwordWeak": "密碼較弱",
    "passwordMedium": "密碼中等",
    "passwordStrong": "密碼較強",
    "passwordMismatch": "兩次密碼不一致",
    "passwordError": "密碼錯誤",
    "bindEmail": "綁定電子郵件",
    "bindEmailIntro": "為了您的資金安全，請綁定電子郵件",
    "emailForRecovery": "用於找回密碼",
    "emailRequired": "電子郵件不能為空",
    "codeRequired": "驗證碼不能為空",
    "invitationCode": "邀請碼",
    "enterInvitationCode": "請輸入邀請碼（選填）",
    "verificationFailed": "校驗失敗",
    "walletReady": "钱包已创建",
    "walletCreatedSuccess": "欢迎回来!",
    "walletExploreTip": "WinPay 全功能已为您开启",
    "firstExploreCreateTitle": "钱包创建成功!",
    "firstExploreRegisterTitle": "登录成功!",
    "firstExploreLoginTitle": "欢迎回来！",
    "firstExploreImportTitle": "钱包导入成功！",
    "firstExploreCreateSubtitle": "现在可以探索公链的加密钱包",
    "firstExploreDefaultSubtitle": "WinPay 全功能已为您开启",
    "startExplore": "開始探索",
    "importTitle": "輸入助記詞或私鑰",
    "importWalletTip": "助记词之间用空格隔开。支持任意钱包的助记词或私钥导入。",
    "importPlaceholder": "輸入助記詞或私鑰",
    "importInvalid": "输入有误",
    "importTip1": "WinPay Wallet 不会记录您的助记词或私钥，权限用户自管，资产由你掌控。",
    "importTip2": "请确保周围没有其他人或摄像头。",
    "importTip3": "建議您手動輸入或掃描條碼導入您的助記詞或私鑰。",
    "continue": "繼續",
    "backupWarnTitle": "備份前請謹記！",
    "backupTipWrite": "建議手寫抄錄",
    "backupTipNoCopy": "請勿複製保存",
    "backupTipNoScreenshot": "請勿截圖保存",
    "backupWarn1Title": "助記詞相當於您的錢包密碼",
    "backupWarn1Desc": "获得助记词等于获得资产所有权，一旦泄露资产将不再安全",
    "backupWarn2Title": "請手寫抄錄或存儲於冷錢包等離線設備中",
    "backupWarn2Desc": "若複製或截圖保存，助記詞有可能洩露",
    "backupWarn3Title": "將助記詞存放在安全的地方",
    "backupWarn3Desc": "一旦丟失資產將無法找回",
    "backupWarnCheck": "助记词由您个人保管，请务必备份，一旦丢失资产将无法找回！",
    "backupMnemonic": "備份助記詞",
    "mnemonicDesc": "助記詞相當於您的錢包密碼，取得助記詞等同於取得錢包資產所有權，一旦洩露資產將不再安全，請妥善備份保管助記詞。",
    "verifyMnemonicTitle": "驗證助記詞",
    "verifyMnemonicTip": "請按順序驗證助記詞",
    "ordinalNumber": "第{number}个",
    "mnemonicCheckFailed": "助記詞驗證失敗",
    "mnemonicCheckSuccess": "助記詞驗證成功",
    "mnemonicUnavailable": "当前钱包暂无助记词备份信息",
    "verifyWalletPassword": "请输入支付密码",
    "forgotPasswordRecovery": "忘記密碼？找回密碼",
    "resetPaymentPassword": "找回密碼",
    "resetPaymentPasswordTip": "请通过已绑定邮箱验证后重设支付密码",
    "changePassword": "修改密碼",
    "currentPassword": "當前密碼",
    "enterCurrentPassword": "輸入當前密碼",
    "setPassword": "設定密碼",
    "pleaseSetNewPasswordMin8": "請設定新密碼，新密碼不少於 8 位",
    "newPassword": "新密碼",
    "setNewPasswordMin8": "请设置新密码，至少 8 位",
    "enterNewPassword": "輸入新密碼",
    "confirmNewPassword": "確定新密碼",
    "setNewPasswordAgain": "請再次確認新設定的密碼",
    "currentPasswordIncorrect": "當前密碼不正確",
    "newPasswordSameAsOld": "新密碼不能與舊密碼相同",
    "passwordsNotMatch": "兩次新密碼不匹配",
    "passwordOnlySavedLocally1": "我知曉密碼僅在本機保存，",
    "passwordOnlySavedLocally2": "忘記後無法找回",
    "noBoundEmailRecover": "您尚未綁定電子郵件，無法找回密碼",
    "goBindEmail": "去綁定電子郵件",
    "boundEmail": "驗證電子郵件",
    "changeSuccess": "修改成功",
    "bindEmailTip": "請先綁定郵箱，才可進行找回密碼操作",
    "bindEmailTip2": "為保障帳戶安全，找回密碼前請先綁定郵箱，以便接收驗證訊息。",
    "bindEmailTip3": "請先綁定郵箱",
    "noBindEmail": "否",
    "canUseWallet": "恭喜您，可以使用錢包啦！",
    "successfullyProtected": "你已經成功地保護了你的錢包。記住保護你的助憶詞安全，丟失後將無法找回！你可以隨時在設置→錢包管理→選擇錢包→導出助憶詞進行備份",
    "startUseApp": "開始使用 WinPay Wallet",
    "next": "下一步"
  },
  "home": {
    "title": "首頁",
    "totalAssets": "總資產估值",
    "receive": "收款",
    "scan": "掃一掃",
    "transfer": "轉賬",
    "topup": "充值",
    "withdraw": "提現",
    "bill": "資金流水",
    "invite": "邀請好友",
    "invitCode": "邀請碼二維碼",
    "more": "更多",
    "recent": "常用功能",
    "community": "社区动态",
    "token": "代幣",
    "turnover": "明细",
    "nft": "NFT",
    "accountAssets": "帳戶資產",
    "cardAssets": "卡內資產",
    "cardWallet": "卡片",
    "backup": "去備份",
    "winpayCardPayment": "WinPay 虛擬卡 + 實體卡雙重支付加持",
    "applyExclusiveCard": "申請專屬卡",
    "nodeFast": "节点正常",
    "nodeSlow": "节点较慢",
    "nodeBad": "节点异常",
    "node": "节点",
    "viewAccount": "選擇帳戶",
    "selectAccount": "選擇帳戶",
    "selectNode": "選擇節點",
    "blockHeightExplain": "节点延迟越低、区块高度越新，通常代表节点连接状态越好。",
    "recommendNode": "推薦節點",
    "blockHeight": "區塊高度",
    "currentAccountNotSupport": "当前账户暂不支持该网络",
    "noData": "暫無數據",
    "actionTodo": "暫未開放",
    "cardTailNo": "尾號",
    "tradeSuccess": "交易成功",
    "tradeFailed": "交易失敗",
    "kycRetryRequired": "您的 KYC 認證失敗，需要再次認證！",
    "viewNow": "立即查看"
  },
  "wallet": {
    "chooseCoin": "選擇其他幣種",
    "selectToken": "選擇代幣",
    "chooseNetwork": "選擇網絡",
    "copyAddress": "複製地址",
    "copySuccess": "複製成功",
    "copyFailed": "複製失敗",
    "saveSuccess": "保存成功",
    "saveFailed": "保存失败",
    "depositAddress": "充值地址",
    "topupNotes": "注意事項：",
    "topupNote1Prefix": "1. 充值金額以",
    "topupNote1Highlight1": "‘實際到帳’",
    "topupNote1Middle": "為準，不同平台的",
    "topupNote1Highlight2": "‘實際到帳’",
    "topupNote1Suffix": "是扣除不同平台手续费(由转出的平台收取)之后的金额",
    "topupNote2": "2.请勿向上述地址充值任何非USDT资产，否则资产将不可找回",
    "topupNote3": "3.您充值至上述地址后,需要整个网络节点的确认,60次网络确认后到账,910次网络确认后可提币",
    "withdrawAddress": "提现地址",
    "enterWithdrawAddress": "請輸入提現地址",
    "withdrawAmount": "提现数量",
    "withdrawAmountLabel": "數量",
    "maxAmountLabel": "最大金额",
    "available": "可用",
    "enterAmount": "請輸入數量",
    "enterWithdrawAmount": "請輸入提現金額",
    "all": "全部",
    "fee": "手續費",
    "received": "預計到帳",
    "submitWithdraw": "提交提現申請",
    "withdrawNotes": "注意事項：",
    "withdrawNote1Prefix": "1．最小提币数量为 ",
    "withdrawNote2": "2．请务必保证提币地址的准确性，否则资产将无法找回",
    "withdrawNote3Prefix": "3. 通過審核後",
    "withdrawNote3Suffix": "小時到帳。網路原因可能有延遲",
    "withdrawNote4": "4. 如長時間未到帳，請聯繫客服核查",
    "withdrawUnavailable": "提幣暫未開放",
    "withdrawConfirm": "确认提交提现吗？",
    "withdrawSuccess": "提幣申請提交成功，請等待管理員審核",
    "billTitle": "資金流水",
    "billDetailTitle": "詳情",
    "noBill": "暂无还没有数据",
    "noBillDetail": "暫無相關數據",
    "assetType": "類型",
    "recordType": "流水类型",
    "billTransactionType": "交易類型",
    "billTransferFriend": "收款好友",
    "billTransferFriendId": "收款好友ID",
    "billTimeLabel": "時間",
    "choosePricingFiat": "選擇計價法幣",
    "hotFeatures": "热门功能",
    "moreFeatures": "更多功能",
    "walletFeatures": "热门功能",
    "cardFeatures": "卡片功能",
    "otherFeatures": "其他功能",
    "payment": "收款",
    "scanCode": "掃一掃",
    "failed": "失敗",
    "walletBackup": "钱包备份",
    "openCard": "立即開卡",
    "physicalCard": "實體卡功能",
    "physicalUnavailable": "本次實體卡功能暫未開放，敬請期待！",
    "activateCard": "激活實體卡",
    "physicalTransfer": "实体卡转账",
    "fundTransfer": "劃轉",
    "fundTransferUnavailable": "功能暫未開放，敬請期待！",
    "receiveAddress": "收款地址",
    "userId": "用戶 ID",
    "transferFriendId": "轉賬好友 ID",
    "transferFriend": "轉賬好友",
    "transferToUser": "轉給 ZorPay 用戶",
    "transferToExternalWallet": "轉給外部錢包",
    "transferIdentityVerification": "身份驗證",
    "transferEmailVerificationDesc": "為保障賬戶安全，轉賬前請完成郵箱驗證",
    "transferVerifyEmail": "驗證郵箱",
    "transferEmailCodeExpires": "郵箱驗證碼有效期10分鐘",
    "receiveUser": "收款用戶",
    "saveCollectionCode": "保存收款碼",
    "transferInProperty": "仅可向 {network} 转入资产",
    "receiveTips": "收款提示",
    "receiveTip1": "请确认转入资产与当前网络一致。",
    "receiveTip2": "转入错误网络或错误币种可能导致资产无法找回。",
    "openCamera": "打开摄像头",
    "closeCamera": "关闭摄像头",
    "pasteScanResult": "粘贴或输入扫码结果",
    "scanResult": "扫码结果",
    "cameraUnavailable": "当前浏览器无法打开摄像头",
    "cameraPermissionDenied": "浏览器未允许访问摄像头，请先开启相机权限",
    "cameraPermissionHint": "如未弹出授权框，请检查浏览器站点权限里的“相机”是否已允许。",
    "cameraNotFound": "未检测到可用摄像头设备",
    "cameraInUse": "摄像头正在被其他应用占用，请关闭后重试",
    "cameraConstraintFailed": "当前设备不支持所请求的摄像头模式，已自动回退后仍无法打开",
    "cameraSecureContextRequired": "当前页面环境不支持调用摄像头，请在安全浏览器环境中打开",
    "cameraSecureContextHint": "安卓浏览器里，网页调用摄像头通常要求 HTTPS 或 localhost。使用局域网 http 地址时，往往不会直接弹出相机权限。",
    "cameraGuideTitle": "无法打开相机",
    "iosCameraGuideTitle": "iPhone 相机说明",
    "androidCameraGuideTitle": "安卓相机说明",
    "cameraPermissionGuide": "1. 在 iPhone Safari 中点击地址栏左侧的“aA”或页面菜单。<br/>2. 打开“网站设置”，将“摄像头”改为“允许”。<br/>3. 返回当前页面并刷新，再重新点击扫码。<br/>4. 如果之前点过“不允许”，也可以去 iPhone“设置 - Safari浏览器”里检查相机权限。",
    "cameraSecureGuide": "当前页面必须在安全环境下才能调用相机。<br/>1. 请确认你打开的是正式域名或安全链接。<br/>2. 返回页面刷新后再重试。<br/>3. 如果仍无效，请改用系统浏览器重新打开。",
    "cameraUnavailableGuide": "1. 请先确认 iPhone 系统相机可正常使用。<br/>2. 在 Safari 中检查当前网站的“摄像头”权限是否已允许。<br/>3. 关闭其他正在占用相机的应用后重试。<br/>4. 如果仍无法打开，请刷新页面或重新进入后再试。",
    "iosCameraPermissionGuide": "1. 在 iPhone Safari 中点击地址栏左侧的“aA”或页面菜单。<br/>2. 打开“网站设置”，将“摄像头”改为“允许”。<br/>3. 返回当前页面并刷新，再重新点击扫码。<br/>4. 如果之前点过“不允许”，也可以去 iPhone“设置 - Safari浏览器”里检查相机权限。",
    "iosCameraSecureGuide": "当前页面必须在安全环境下才能调用相机。<br/>1. 请确认你打开的是正式域名或安全链接。<br/>2. 返回页面刷新后再重试。<br/>3. 如果仍无效，请改用系统浏览器重新打开。",
    "iosCameraUnavailableGuide": "1. 请先确认 iPhone 系统相机可正常使用。<br/>2. 在 Safari 中检查当前网站的“摄像头”权限是否已允许。<br/>3. 关闭其他正在占用相机的应用后重试。<br/>4. 如果仍无法打开，请刷新页面或重新进入后再试。",
    "androidCameraPermissionGuide": "1. 请先在安卓浏览器地址栏或页面设置中查看“网站设置/权限设置”。<br/>2. 将当前网站的“相机”权限改为“允许”。<br/>3. 如果系统弹出过相机权限并被拒绝，请到“手机设置 - 应用 - 浏览器 - 权限”里开启相机权限。<br/>4. 返回页面刷新后，再重新点击扫码。",
    "androidCameraSecureGuide": "当前安卓浏览器通常要求安全环境才能调用相机。<br/>1. 请确认当前页面使用的是正式域名或 HTTPS 链接。<br/>2. 如果你打开的是局域网地址，很多安卓浏览器不会弹出相机权限。<br/>3. 请切换到正式地址后刷新页面再试。",
    "androidCameraUnavailableGuide": "1. 请先确认手机系统相机可以正常打开。<br/>2. 检查浏览器和系统是否都已允许相机权限。<br/>3. 关闭其他占用相机的应用后重试。<br/>4. 如果仍无法打开，请刷新页面或改用系统浏览器再试。",
    "androidScanGuideTitle": "安卓扫码说明",
    "androidScanGuide": "当前安卓浏览器已打开相机，但不支持本页使用的实时扫码能力。<br/>1. 建议优先使用系统浏览器或最新版 Chrome。<br/>2. 确认当前网站相机权限已允许。<br/>3. 刷新页面后重试，如果仍无效，请换支持网页扫码的浏览器。",
    "safariScanGuideTitle": "Safari 扫码说明",
    "safariScanGuide": "当前 iPhone Safari 已打开相机，但不支持本页使用的实时扫码能力。<br/>1. 先确认当前网站的“摄像头”权限已允许。<br/>2. 刷新页面后再重试一次。<br/>3. 如果仍无法识别，请改用支持网页实时扫码的浏览器或在其他入口完成扫码。",
    "scanNotSupportedGuide": "当前浏览器不支持本页使用的实时扫码能力。<br/>1. 请先确认当前网站已获得相机权限。<br/>2. 刷新页面后再重试一次。<br/>3. 如果仍无法识别，请改用系统浏览器或其他支持网页扫码的浏览器。",
    "scanNotSupported": "当前浏览器不支持实时扫码，请使用系统浏览器重试",
    "scanSuccess": "识别成功",
    "transferRecord": "轉賬記錄",
    "directTransfer": "直接轉賬",
    "addressBookTransfer": "地址本轉賬",
    "scanTransfer": "掃碼轉賬",
    "enterOrPasteAddress": "请输入或粘贴地址",
    "enterUserId": "請輸入用戶 ID",
    "enterZorPayId": "請輸入8位 ZorPay ID",
    "onlySupport8DigitUserId": "僅支持輸入8位用戶ID",
    "transferAmount": "轉賬金額",
    "availableAmount": "可用 {amount} {symbol}",
    "walletBalance": "錢包餘額",
    "transferHistory": "轉賬歷史",
    "noTransferRecord": "暂无转账记录",
    "transferConfirm": "确认提交转账吗？",
    "transferNetworkUnsupported": "目前網絡暫不支援該資產轉賬",
    "transferInsufficientBalance": "餘額不足以支付轉賬金額及網絡手續費",
    "haveNotFinishedTransaction": "有未完成的轉賬，請稍後重試",
    "transferSubmitted": "轉賬已提交",
    "transferApplySubmittedTitle": "申請已提交",
    "transferApplySubmitted": "轉賬申請已提交",
    "transferUnderReview": "轉賬審核中",
    "transferReviewEta": "您的轉賬申請已提交，預計1個工作日審核通過後將盡快到賬。",
    "transferSubmitNotice": "轉賬申請提交成功，請勿重複操作",
    "transferViewFlowHint": "您可在【首頁】-功能區【資金流水】查看資金流水情況",
    "transferContactSupport": "遇到問題？聯絡客服",
    "addToken": "添加代幣",
    "addNft": "新增NFT",
    "nftDetail": "NFT 詳情",
    "nftAssets": "資產",
    "nftAssetView": "NFT",
    "nftSendTitle": "發送 NFT",
    "nftSendAsset": "发送资产",
    "sendNft": "發送",
    "removeNft": "刪除",
    "invalidAddress": "请输入正确地址",
    "userIdNotFound": "未找到對應用戶或該用戶未開通目前網絡",
    "nftTransferUnsupported": "当前网络暂不支持 NFT 转账",
    "nftSendSuccess": "發送成功",
    "hotToken": "熱門代幣",
    "hotNft": "熱門NFT",
    "customToken": "自定義代幣",
    "customNft": "自定义NFT",
    "enterContractAddressSearch": "输入合约地址搜索",
    "tokenAddress": "代幣地址",
    "nftAddress": "NFT地址",
    "enterTokenAddress": "請輸入代幣地址",
    "enterNftAddress": "请输入NFT合约",
    "tokenSymbol": "代幣符號",
    "enterTokenSymbol": "請輸入代幣符號",
    "decimalPlaces": "小數位",
    "tokenAdded": "代幣已添加",
    "addSuccess": "添加成功",
    "tokenDetail": "Token 详情",
    "propertyBalance": "資產余額",
    "transferIn": "轉入",
    "transferOut": "轉出",
    "transferInAddress": "轉入地址",
    "transferOutAddress": "轉出地址",
    "transactionId": "交易 ID",
    "blockchainBrowser": "區塊鏈瀏覽器",
    "network": "網絡",
    "pending": "處理中",
    "inTransaction": "交易中",
    "finish": "完成",
    "signTodo": "签名流程迁移中",
    "exportMnemonic": "導出助憶詞",
    "exportPrivateKey": "導出私鑰",
    "sensitiveExportLabel": "需要完成身份验证后查看",
    "securityReminder": "安全提醒",
    "backupTip1": "助记词和私钥代表资产所有权，请离线妥善保管。",
    "backupTip2": "不要截图、录屏或通过聊天工具发送给任何人。",
    "backupTip3": "WinPay 不会保存你的助记词或私钥。",
    "backupSensitiveConfirm": "请确认周围环境安全后再继续。",
    "sensitiveExportTodo": "敏感导出流程迁移中",
    "privateKeyUnavailable": "当前钱包暂无私钥导出信息",
    "specialReminder": "特別提醒",
    "safetyReminder": "安全提醒",
    "privateCarefulExport": "导出私钥后请务必离线妥善保管，一旦泄露将可能造成资产丢失。",
    "clickShowPrivateKeyQr": "點擊展示私鑰二維碼",
    "plaintextPrivateKey": "明文私鑰",
    "copyPrivateKey": "複製私鑰",
    "copyPrivateKeyAfter": "复制私钥后，务必对私钥进行妥善保管，否则会造成资产丢失。",
    "copyMnemonicAfter1": "複製助記詞後，",
    "copyMnemonicAfter2": "不要打開其他應用",
    "copyMnemonicAfter3": "以防剪貼簿內容洩露。",
    "notPasteMnemonic1": "不要將助記詞貼到",
    "notPasteMnemonic2": "任何連網的應用中進行粘貼，",
    "notPasteMnemonic3": "不要使用",
    "notPasteMnemonic4": "任何網盤、聊天工具進行備份",
    "notShareMnemonic1": "不將助憶詞分享給任何人，請注意，",
    "notShareMnemonic2": "我們永遠不會向您索要助憶詞",
    "winpayCard": "WinPay Card",
    "openCardTitle": "申请开卡",
    "openCardDesc": "连接账户资产与全球支付场景",
    "openCardProcess": "开卡流程",
    "openCardStep1": "KYC 認證",
    "openCardStep2": "選擇卡片",
    "openCardStep3": "完成开通",
    "cardSecure": "安全",
    "cardSecureDesc": "账户风控保护",
    "cardGlobal": "全球",
    "cardGlobalDesc": "多场景支付",
    "cardAsset": "資產",
    "cardAssetDesc": "余额统一管理",
    "openCardNow": "申请开卡",
    "cardKycTodo": "开卡 KYC 流程迁移中",
    "activatePhysicalCard": "激活實體卡",
    "activatePhysicalCardEntry": "激活實體卡",
    "activatePhysicalDesc": "收到实体卡后输入卡号和激活码完成激活",
    "cardNumber": "卡號",
    "enterCardNumber": "请输入卡号",
    "activeCode": "激活码",
    "enterActiveCode": "请输入激活码",
    "emailCode": "電子郵件驗證碼",
    "enterEmailCode": "请输入邮箱验证码",
    "sendCode": "发送验证码",
    "activateNow": "立即激活",
    "activateTip1": "请在收到实体卡后再进行激活。",
    "activateTip2": "激活前请核对卡号、邮箱验证码和激活码。",
    "cardApiTodo": "卡片接口迁移中",
    "completeCardActiveForm": "请完善激活信息",
    "activateSuccess": "激活成功",
    "submitSuccess": "提交成功",
    "physicalTransferDesc": "实体卡之间的余额划转",
    "fromCard": "转出卡片",
    "selectCard": "请选择",
    "toCard": "转入卡片",
    "enterTargetCard": "请输入转入卡号",
    "remark": "備註",
    "optionalRemark": "选填",
    "completePhysicalTransferForm": "请完善转账信息",
    "transferFrom": "从",
    "transferTo": "到",
    "fundingAccount": "資金帳戶",
    "exchangeCoin": "兑换币种",
    "availableBalance": "可用余额",
    "transferInAmount": "转入金额",
    "transferOutAmount": "转出金额",
    "withdrawFeeLabel": "提現手續費"
  },
  "invite": {
    "title": "邀請好友",
    "inviteNow": "立即邀請",
    "share": "分享",
    "claim": "領取",
    "claimSuccess": "領取成功",
    "pendingClaim": "待領取",
    "claimableAmount": "可領取（USDT）",
    "claimed": "已領取",
    "expired": "已過期",
    "copyUrl": "複製URL",
    "saveQrCode": "保存二維碼",
    "saveImage": "保存",
    "posterTitle": "一張卡 · 輕鬆全球支付",
    "posterTagline": "全球支付 · 一站式錢包",
    "pointsRules": "邀請規則",
    "referralStepsTitle": "分享邀請·流程步驟",
    "pointsRulesComingSoon": "積分獎勵規則即將開放，敬請期待！",
    "heroTitle": "邀請開卡·獎勵計劃",
    "hero1": "推薦並賺取最多",
    "hero2": "60%",
    "hero3": "佣金",
    "heroDesc": "查看活動規則，開啟邀請獎勵",
    "partner": "合作夥伴",
    "partnerPromotion": "推薦成為 WinPay 合作夥伴，專享推廣高額收益",
    "partnerJoinNow": "立即加入",
    "coursePromotionTitle": "公開課！",
    "purchaseCardToInvite": "購卡後開啟邀請",
    "purchaseCardToInviteDesc": "您已完成身分驗證，購買虛擬卡和實體卡後，即可取得專屬邀請碼與邀請連結，開啟邀請獎勵。",
    "unlockInviteTitle": "解鎖邀請碼與邀請連結條件：",
    "unlockInviteDesc": "購買任意卡後，即可取得專屬邀請碼與邀請連結",
    "purchaseCardToInviteLater": "稍後再說",
    "purchaseCardToInviteNow": "立即購卡",
    "kycPurchaseCardDesc": "請先完成身分驗證後購買虛擬卡、實體卡，即可解鎖此功能",
    "coursePromotionDesc": "點擊查看課程，開啟邀請獎勵",
    "cardOpeningCommission": "開卡返佣",
    "spendingCommission": "消費返佣",
    "commissionRefundDeduction": "返佣退款扣除",
    "reservedReward": "預留",
    "courseCommission": "課程返佣",
    "globalDirectorCourseCommission": "全球董事課程返佣",
    "globalDirectorCardOpeningCommission": "全球董事開卡返佣",
    "teamBonusPoolCardOpeningCommission": "團隊獎金池開卡返佣",
    "teamBonusPoolCourseCommission": "團隊獎金池課程返佣",
    "globalDirectorTeamCardOpeningCommission": "全球董事團隊開卡返佣",
    "globalDirectorTeamCourseCommission": "全球董事團隊課程返佣",
    "inviteFriendCardOpeningCommission": "邀請好友開卡返佣",
    "invitationCommission": "邀請返佣",
    "purchaseCommission": "購卡返佣",
    "consumptionCommission": "课程返佣",
    "friendCourseCommission": "好友課程返佣",
    "inviteFriendCourseCommission": "邀請好友課程返佣",
    "monthlyCommission": "月度返佣",
    "monthlyBonusPoolCommission": "團隊獎金池返佣",
    "globalDirectorExclusiveCommission": "全球董事專屬返佣",
    "globalDirectorCardOpeningReward": "全球董事開卡獎勵",
    "monthlyCommissionTitle": "團隊返佣",
    "monthlyCommissionIntro": "累計有效直推開卡 ≥ 5 人，即可獲得 V3 團隊獎勵資格。",
    "monthlyCommissionTip1": "開卡返佣結算",
    "monthlyCommissionTip1Desc": "進入V3後，邀請好友完成有效開卡獲得獎勵。",
    "monthlyCommissionTip2": "等級分配獎勵",
    "monthlyCommissionTip2Desc": "半月結算，根據有效直推人數確定對應T檔。",
    "monthlyCommissionTip3": "團隊獎勵說明",
    "monthlyCommissionTip3Desc": "好友完成有效購課後，將為半月團隊獎勵池貢獻獎勵額度。",
    "monthlyCommissionTip4": "團隊獎勵結算",
    "monthlyCommissionTip4Desc": "半月結算，具體金額以系統最終結算結果為準。",
    "consumptionRefund": "邀請好友開卡返佣",
    "friendConsumptionRewardRefund": "好友消費返佣退款",
    "rewardRecordCardOpeningTitle": "邀請 [{friendName}] 開卡返佣",
    "rewardRecordConsumptionTitle": "[{friendName}] 消費返佣",
    "rewardRecordRefundTitle": "[{friendName}] 消費退款",
    "rewardRecordCourseCommissionTitle": "[{friendName}] 課程返佣",
    "rewardRecordFriendCourseCommissionTitle": "邀請 [{friendName}] 好友課程返佣",
    "rewardRecordMonthlyCommissionTitle": "[{friendName}] 月度返佣",
    "rewardRecordMonthlyBonusPoolTitle": "[{friendName}] 月度獎金池返佣",
    "rewardRecordRegistrationTitle": "邀請 [{friendName}] 註冊",
    "invitationTotal": "有效邀請",
    "notUnlocked": "尚未解鎖",
    "purchaseCommissionTitle": "購卡返佣",
    "purchaseCommissionIntro": "邀請好友成功開通WinPay卡,即可獲得開卡佣金獎勵。",
    "purchaseCommissionTip1": "等級越高，返佣比例越高，",
    "purchaseCommissionTip1Desc": "邀請更多好友開卡，滿足條件後可進入團隊獎金池。",
    "purchaseCommissionTip2": "虛擬卡與實體卡均享受同等返佣",
    "purchaseCommissionTip2Desc": "開卡成功即可計算佣金。",
    "purchaseCommissionTip3": "開卡佣金將在開卡完成後自動結算",
    "purchaseCommissionTip3Desc": "3個工作日之內發放至您的總資產帳戶。",
    "purchaseCommissionTip3DescPrefix": "",
    "purchaseCommissionTip3Time": "開卡成功，佣金秒結。",
    "purchaseCommissionTip3DescSuffix": "獎勵自動發放至您的總資產帳戶。",
    "purchaseCommissionConfirm": "我知道了",
    "consumptionCommissionTitle": "课程返佣",
    "consumptionCommissionIntro": "購買課程，即可獲得有效課程專屬佣金獎勵。",
    "consumptionCommissionTip1": "消費返佣規則",
    "consumptionCommissionTip1Desc": "邀請好友越多，獲取課程獎勵越高",
    "consumptionCommissionTip2": "消費退款規則",
    "consumptionCommissionTip2Desc": "30天內發生退款：該筆消費不產生返佣。",
    "consumptionCommissionTip2Partial": "部分退款",
    "consumptionCommissionTip2PartialDesc": "按實際有效消費金額重新計算返佣。",
    "consumptionCommissionTip3": "已到帳返佣發生退款",
    "consumptionCommissionTip3Desc": "已結算返佣對應訂單發生退款、撤銷或部分退回，用戶未提返佣，平台將有權追回已發放返佣。",
    "points": "我的積分",
    "inviteMethod": "邀請方式",
    "invitationCode": "我的邀請碼",
    "shareQr": "邀請碼二維碼",
    "invitationLink": "我的邀請鏈接",
    "myExclusiveInvite": "我的專屬邀請",
    "invitationCodeShort": "邀請碼",
    "invitationLinkShort": "邀請連結",
    "invitationRelationTip": "好友使用此邀請碼/鏈接都會與您關聯，您將獲取該產品的返佣",
    "recommender": "推薦人",
    "enterRecommenderCode": "請輸入推薦碼",
    "scanRecommenderCode": "掃描推薦碼",
    "viewFullRecords": "查看完整記錄",
    "personUnit": "人",
    "invitedFriendsTotal": "有效邀請總數",
    "pendingCommission": "待結算返佣",
    "totalCommission": "累計總返佣",
    "parentCode": "邀请人",
    "enterParentCode": "请输入邀请码",
    "bind": "綁定",
    "bound": "已綁定",
    "rewardDetails": "獎勵明細",
    "commissionDetails": "返佣明細",
    "recommendedUsers": "推薦用戶",
    "tradingFriends": "交易好友",
    "registeredFriends": "註冊好友",
    "noRecommendedUsers": "暫無推薦用戶",
    "totalCommissionUsdt": "總佣金（USDT）",
    "withdrawable": "可提現",
    "pendingSettlement": "待結算",
    "pendingSettlementTitle": "待結算（USDT）",
    "pendingSettlementDescription": "您將立即看到您的返佣，但需要先結算才能領取。如果購買退款，返佣也將被撤銷。",
    "pendingSettlementQuestion": "我的返佣何時結算？",
    "pendingSettlementMonthlyCommission": "團隊返佣：半月結算",
    "pendingSettlementCardActivation": "卡激活：成功開卡後，佣金秒結到帳",
    "pendingSettlementTransaction": "課程返佣：購買核銷後，佣金秒結到帳",
    "settled": "已結算",
    "myRewards": "我的獎勵",
    "date": "日期",
    "selectDate": "選擇日期",
    "rewardSuccess": "成功",
    "rewardReady": "可領取",
    "rewardVoided": "已作廢",
    "rewardPartialRefund": "部分退款",
    "rewardRefunded": "已退款",
    "rewardDeducted": "已扣除",
    "rewardDeductionFailed": "扣除失敗",
    "rewardCredited": "已到賬",
    "rewardCardType": "卡片類型",
    "rewardType": "獎勵類型",
    "friendNickname": "好友暱稱",
    "invitationRelation": "邀請關係",
    "indirectFriend": "間推好友",
    "rewardAmount": "獎勵金額",
    "percentageWeight": "佔比權重",
    "deductionAmount": "扣除金額",
    "commissionAllocationRatio": "分配佔比",
    "commissionAllocationRatioUnavailable": "暫未提供",
    "commissionSettlementCycle": "結算週期",
    "teamCommissionSettlementCycle": "半月結算",
    "commissionSettlementMethod": "結算方式",
    "commissionInstantSettlement": "秒結到帳",
    "commissionTriggerTime": "返佣觸發時間",
    "commissionSettlementTime": "返佣結算時間",
    "friendConsumptionRefundTime": "好友消費退款時間",
    "commissionDeductionTime": "返佣扣除時間",
    "commissionStatus": "返佣狀態",
    "rewardDetailsAmountPrefix": "奖励明细 ",
    "balanceAfter": "剩余 ",
    "noRewardRecords": "暂无奖励记录",
    "inviteSteps": "邀請步驟",
    "step1": "分享鏈接或邀請碼給您的朋友",
    "step2": "受邀好友透過連結或邀請碼完成卡片申請或課程購買",
    "step3": "朋友開通卡片或購買課程，您將獲得返佣獎勵"
  },
  "task": {
    "title": "簽到賺積分",
    "dailyCheckIn": "每日簽到",
    "howToGetPoints": "如何獲取積分",
    "myPoints": "我的積分",
    "dailyTasks": "每日任務",
    "checkInTotal": "已經累計簽到",
    "days": "天",
    "checkInRules": "簽到規則",
    "checkInRuleOne": "1.每日簽到，每次展示7天；獎勵依次為:5/10/15遞增積分，每3天一循環;",
    "checkInRuleTwo": "2.中途漏簽，則從5積分開始重新計算獎勵。",
    "moreCheckInsMorePoints": "簽到越多，積分越多~",
    "checkedInDaysPrefix": "已連續簽到",
    "checkedInDaysSuffix": "天",
    "checkedInTodayTomorrow": "今日已簽到，明天再來吧~",
    "routineTasks": "日常任務",
    "dailyPointsLimit": "每日獲取積分上限1000",
    "basicGrowth": "基礎成長",
    "completeSignature": "完善簽名",
    "signatureDone": "完成簽名",
    "pointsPlusOne": "積分+1",
    "goFollow": "去關注",
    "postMoments": "發朋友圈",
    "perPost": "每發1條",
    "monday": "週一",
    "tuesday": "週二",
    "wednesday": "週三",
    "thursday": "週四",
    "friday": "週五",
    "saturday": "週六",
    "sunday": "週日"
  },
  "card": {
    "title": "卡片",
    "myCards": "我的卡片",
    "openCard": "申請卡片",
    "GoOpenCard": "去開卡",
    "benefits": "卡片權益",
    "bill": "帳單",
    "empty": "暫無相關卡片",
    "virtualCard": "虛擬卡",
    "physicalCard": "實體卡",
    "courseCard": "課程卡",
    "courseGiftNoticePhysical": "成功購買實體卡，即可獲贈專屬線下課程。課程連結將發送至您的註冊電郵，點擊即可查看詳情及參與方式。",
    "courseGiftNoticeVirtual": "成功購買虛擬卡，即可獲贈專屬線下課程。課程連結將發送至您的註冊電郵，點擊即可查看詳情及參與方式。",
    "applyCard": "申请开卡",
    "applyNow": "立即開卡",
    "virtualDesc": "隨時隨地，線上線下非接觸式支付！",
    "physicalDesc": "免年費，無隱藏費用。支持全球ATM取現！",
    "applyCardTypeOne": "申請虛擬卡",
    "applyCardTypeTwo": "申請實體卡",
    "applyCardTip1": "線上申請虛擬卡，支援線上線下支付",
    "applyCardTip2": "實體卡支援郵寄到家，支援 ATM 取現與 POS 機消費",
    "applyCardTip3": "線上申領，線下代辦實體卡，簽收激活即可享用全部功能",
    "applyCardTip4": "查看並管理虛擬卡與實體卡",
    "applyCourseExclusiveCard": "申請課程專屬卡",
    "applyCourseExclusiveCardDesc": "僅展示權益，免認證開通，不支援充值、消費及提現",
    "courseCardApplyTitle": "申請課程專屬卡",
    "courseCardNotice": "課程專屬卡僅用於權益展示，無需身份認證即可開通，暫不支援充值、消費及提現功能。",
    "openingFee": "開卡費",
    "cardType": "卡片類型",
    "courseExclusiveCard": "課程專屬卡",
    "identityVerification": "身份認證",
    "noAuthenticationRequired": "無需認證",
    "rechargeSupported": "可否充值",
    "spendingSupported": "可否消費",
    "withdrawalSupported": "可否提現",
    "notSupportedYet": "暫不支援",
    "applicableScenes": "精選適用場景",
    "studyImprovement": "學習提升",
    "promotionMonetization": "推廣變現",
    "brandCooperation": "品牌合作",
    "openingBenefits": "開通權益",
    "receiveCourseCard": "領取卡片",
    "receiveCourseCardDesc": "購買課程專屬卡，即獲專屬課程卡一張。",
    "promotionRights": "開通推廣權限",
    "promotionRightsDesc": "完成開卡認證、支付成功後，即可開通專屬課程推廣權限。",
    "openNow": "立即開卡 {amount} USDT",
    "purchaseSuccessTitle": "購卡成功",
    "purchaseSuccessful": "購卡成功",
    "purchaseSuccessDesc": "課程專屬卡權益已生效",
    "promotionActivated": "推廣權限已開通",
    "promotionActivatedDesc": "現在即可邀請好友參與推廣",
    "cardSecured": "贈卡權益已為您保留",
    "cardSecuredDesc": "您可獲贈一張虛擬卡或實體卡。贈卡正在製作中，上線後將通知您領取。",
    "goPromote": "去推廣",
    "done": "完成",
    "directPromotion": "直接推廣",
    "pendingOpen": "待開放",
    "kycDialogTitle": "需要身份驗證",
    "kycDialogDesc": "請先完成身份驗證以解鎖此功能",
    "kycDialogAction": "立即 KYC",
    "useInstruction": "綁卡指南",
    "virtualCardUseInstruction": "虛擬卡使用說明",
    "entityCardUseInstruction": "實體卡使用說明",
    "useInstructionText1": "虛擬卡可綁定支付寶、美團，支援線上消費。",
    "useInstructionText2": "實體卡可綁定支付寶、美團，支援線上線下全場景消費；支援 POS 機刷卡；ATM 取現。",
    "useInstructionText3": "為保障您的資金安全，請勿將卡片資訊，如卡號、有效期、CVV 碼洩露給他人！",
    "useInstructionText4": "解除綁定卡片後不可恢復使用，一旦確認解除綁定即不可逆，請謹慎操作！",
    "useInstructionText5": "解除綁定卡片後，開卡費不予退還，但卡內如有剩餘金額將退回錢包。",
    "useInstructionText6": "如遇問題，可透過我的 - 聯絡我們 - 線上客服聯絡官方客服處理！",
    "useInstructionText7": "如何綁定",
    "useInstructionText8": "支付寶",
    "useInstructionText9": "按照以下步驟完成綁卡，操作簡單快捷",
    "useInstructionText10": "打開支付寶",
    "useInstructionText11": "進入支付寶 App，點擊我的",
    "useInstructionText12": "進入銀行卡",
    "useInstructionText13": "在銀行卡或支付設定中選擇綁卡入口",
    "useInstructionText14": "新增銀行卡",
    "useInstructionText15": "點擊新增銀行卡，輸入 WinPay 卡號",
    "useInstructionText16": "填寫卡片資訊",
    "useInstructionText17": "依提示填寫有效期、CVV 碼及驗證碼等資訊",
    "useInstructionText18": "完成驗證",
    "useInstructionText19": "提交後完成短信或安全驗證，綁卡成功後即可使用",
    "useInstructionText20": "用卡說明",
    "bindCardInfo1": "精選適用場景支援 Alipay 的 Visa 卡，可快速綁定 Alipay，按照以下步驟即可完成綁卡操作",
    "bindCardInfo2": "精選適用場景支援 Google Pay 的 Visa 卡，可快速綁定 Google Pay，按照以下步驟即可完成綁卡操作",
    "bindCardInfo3": "精選適用場景支援 Apple Pay 的 Visa 卡，可快速綁定 Apple Pay，按照以下步驟即可完成綁卡操作",
    "bindCardInfo4": "下載並開啟 Google Pay，登入帳戶",
    "bindCardInfo5": "進入 Google Pay 首頁，點擊「新增付款卡」",
    "bindCardInfo6": "新增付款卡",
    "bindCardInfo7": "點擊「新增信用卡或扣帳卡」",
    "bindCardInfo8": "填寫個人資料",
    "bindCardInfo9": "填寫卡片資料和城市地址等，點擊「儲存並繼續」",
    "bindCardInfo10": "進入發卡機構條款頁面",
    "bindCardInfo11": "滑動至底部，點擊「繼續」",
    "bindCardInfo12": "選擇「驗證方式」後點擊「取得驗證碼」，將驗證碼填入驗證區，驗證成功後即可完成綁定",
    "bindCardInfo13": "下載並開啟 Apple Pay，登入帳戶",
    "bindCardInfo14": "進入 Apple Pay 首頁，點擊「新增付款卡」",
    "bindCardInfo15": "掃描或手動輸入卡片詳細資料",
    "bindCardInfo16": "填寫卡號、英文姓名、有效期和安全碼等資料",
    "bindCardInfo17": "進入條款與條件頁面",
    "bindCardInfo18": "滑動至底部，點擊「同意」",
    "coreAdvantages": "核心優勢",
    "recommendedAudience": "推薦人群",
    "cardScene": "卡片场景",
    "transferIn": "轉入",
    "transferOut": "轉出",
    "atmPassword": "ATM密碼",
    "cardInfo": "卡片信息",
    "mycard": "我的卡片",
    "benefit": "卡片權益",
    "recentTrade": "帳單",
    "viewAll": "查看全部",
    "noTrade": "暂无交易记录",
    "noTradeEmpty": "暫無相關數據",
    "inUse": "使用中",
    "inactive": "未激活",
    "frozen": "凍結中",
    "processing": "處理中",
    "success": "成功",
    "failed": "失敗",
    "cardSensitiveTodo": "敏感卡片信息查看流程迁移中",
    "cardWallet": "卡片",
    "cardBenefits": "卡片權益",
    "noBenefit": "暂无权益信息",
    "withdrawMin": "最小提现",
    "withdrawMax": "最大提现",
    "rechargeMin": "最小充值",
    "rechargeMax": "最大充值",
    "monthlyLimit": "月限额",
    "billDetail": "賬單明細",
    "feeRate": "支付手续费",
    "chargeFeeLabel": "充值手續費",
    "rechargeFeeLabel": "首充金额",
    "withdrawFeeLabel": "提現手續費",
    "payFeeLabel": "消費手續費",
    "selectCardTemplate": "选择卡片模板",
    "selectScene": "选择使用场景",
    "cardTemplate": "卡片模板",
    "scene": "场景",
    "selectTimeRange": "選擇時間範圍",
    "timeRangeTip": "切換至“近180天”查看獎勵明細",
    "last30Days": "最近 30 天",
    "last90Days": "最近 90 天",
    "last180Days": "最近 180 天",
    "currentScenario": "当前场景",
    "supportedScenes": "适用场景",
    "supportedPlatforms": "适用平台",
    "platformHint": "以发卡方最新支持为准",
    "openCardAmount": "開卡費",
    "openCardAmountTip": "包含开卡费和首充金额",
    "openFeeNoticePrefix": "開卡費",
    "openFeeNoticeSuffix": "充值至卡內，用於保持卡片啟用",
    "firstRechargeTip": "开卡需支付 {amount} {symbol}，并额外首充 {charge} {symbol}",
    "cardUsageLimit": "消费限额",
    "monthlyCardUsageLimit": "消費限額/月",
    "cardTitlePrefix": "卡片 ",
    "prepaidCard": "預付卡",
    "identityInfo": "身份資訊",
    "identityInfoTip": "实名资料将用于开卡校验",
    "firstName": "名字",
    "lastName": "姓氏",
    "identityInfoEmpty": "请先完成实名资料填写",
    "agreementPrefix": "已閱讀並同意",
    "optionalInvitationCode": "請輸入邀請碼（選填）",
    "openCardNotice": "开卡说明",
    "openCardNotice1": "开卡费用由开卡费和首充金额组成，提交后由系统自动执行。",
    "openCardNotice2": "不同场景支持的平台和费率可能不同，请以发卡结果与渠道规则为准。",
    "openCardNotice3": "若后续需要申请实体卡，请先确保已持有可绑定的虚拟卡。",
    "termsAgree": "我已阅读并同意《用户协议》与《隐私政策》",
    "agreeFirst": "请先勾选协议后再继续",
    "noCardTemplate": "暂无可申请的卡片模板",
    "balanceOverview": "卡片權益總覽",
    "monthlyFee": "月費",
    "withdrawNotice": "实体卡最低提现 {amount} {symbol}",
    "applyPhysicalCard": "申请实体卡",
    "physicalApplyDesc": "完成实名后选择模板并填写收货信息，支付后等待制卡配送",
    "shippingFee": "运费",
    "shippingFree": "包邮",
    "applicationFee": "申请费用",
    "applicationFeeLabel": "申請費用：",
    "recentTradeScene": "精選適用場景",
    "physicalSceneDesc": "各類線下線上消費",
    "physicalOrderNotice": "实体卡申请说明",
    "physicalNotice1": "申请实体卡前，请先确保已开通可绑定的虚拟卡。",
    "physicalNotice2": "提交并支付成功后，卡片将进入制作与配送流程。",
    "physicalNotice3": "收到卡片后，请在实体卡激活页完成激活后再使用。",
    "fillShippingInfo": "填寫收貨資訊",
    "requireVirtualCardFirst": "请先开通可绑定的虚拟卡后再申请实体卡",
    "cardInfoTitle": "卡信息",
    "shippingInfoTitle": "收貨資訊",
    "sameAsVirtualCard": "與虛擬卡一致",
    "receiverName": "姓名",
    "enterReceiverName": "請輸入",
    "completeAllInfo": "請完善全部資訊",
    "addressMinLength": "详细地址最少 5 个字符",
    "completeShippingAddress": "请完善收货信息，详细地址至少 5 个字符",
    "saveLabel": "保存",
    "confirmOrder": "確認訂單資訊",
    "payPhysicalCardConfirm": "确认提交实体卡订单并支付吗？",
    "payNow": "立即支付",
    "orderPaid": "支付成功",
    "paymentDetail": "支付詳情",
    "paymentFee": "支付的費用",
    "paymentSuccess": "支付成功",
    "paymentSuccessDesc": "您的卡片正在製作中，預計 7-14 個工作日內送達~",
    "physicalCardMakingTip": "實體卡製作週期比普通卡片稍長，請耐心等候。收到後請先激活再使用。",
    "paymentAmount": "支付的費用",
    "physicalArrivalTip1": "实体卡制作周期较普通卡片稍长，请耐心等待。",
    "physicalArrivalTip2": "收到货后，请先激活实体卡，再进行后续使用。",
    "viewPendingCards": "查看未激活卡片",
    "totalAssetsInsufficientBalance": "当前总资产余额不足，请充值后进行后续操作",
    "currentCardInsufficientBalance": "當前卡內資產餘額不足，請充值後再操作",
    "topUpNow": "去充值",
    "pendingPhysicalCards": "未激活卡片",
    "pendingActivate": "未激活",
    "noPendingPhysicalCard": "暂无待激活实体卡",
    "hasInactiveCards": "有卡片未激活",
    "physicalInstruction": "實體卡說明",
    "pendingNotice1": "您已成功申请实体卡，当前卡片正在制作或配送中。",
    "pendingNotice2": "为保障账户安全，在签收并完成激活前，实体卡暂时无法使用。",
    "pendingNotice3": "收到卡片後，點擊下方按鈕即可快速激活。",
    "contactSupport": "聯絡客服",
    "invitationCode": "邀請碼",
    "enterInvitationCode": "請輸入邀請碼（選填）",
    "openCardConfirm": "确认提交开卡申请吗？",
    "openCardSuccess": "开卡申请已提交",
    "kycTitle": "KYC 認證",
    "kycVerify": "KYC 認證",
    "kycRequirement": "完成 KYC 認證後，才可以繼續申請卡片。",
    "kycRequirement1": "请提供真实、准确且与证件一致的信息。",
    "kycRequirement2": "验证结果由服务商审核，可能需要一些时间。",
    "kycIntroTip": "提交真实身份资料后，审核通过即可继续申请虚拟卡。",
    "verifyNow": "立即认证",
    "fillInfo": "填寫資訊",
    "kycFormTip": "请按证件信息填写常用联系方式与开户地址。",
    "contactAndAddress": "联系方式与地址",
    "countryCode": "區號",
    "selectCountryCode": "请选择区号",
    "phoneNumber": "手機號",
    "enterPhone": "請輸入手機號",
    "address": "地址",
    "selectCountry": "请选择国家",
    "selectCountryRegion": "選擇國家/地區",
    "searchCountry": "搜尋國家",
    "selectRegion": "请选择省/州/地区",
    "selectCity": "請選擇城市",
    "enterAddress": "请输入详细地址",
    "postalCode": "邮政编码",
    "enterPostalCode": "请输入邮政编码",
    "completeKycAddress": "请完善地址信息，详细地址至少 5 个字符",
    "kycSubmitted": "信息已提交",
    "kycReview": "信息审核",
    "kycRejected": "KYC 验证被拒绝",
    "kycPending": "信息提交成功待審核",
    "kycApproved": "資訊審核通過",
    "kycRejectedTip": "请根据失败原因修改资料后重新提交。",
    "reviewTip": "审核完成后可以选择卡片进行开卡了",
    "reviewDone": "我知道了",
    "cardCanOpen": "現在可以選擇卡片開卡了",
    "resubmit": "重新提交",
    "failedReason": "失敗原因",
    "activatePending": "有 {count} 张实体卡待激活",
    "oldCardTransferTip": "因 WinPay 升级了虚拟卡与实体卡服务，旧卡暂不支持使用转入 / 转出功能。",
    "oldCardServiceUpgradeNotice": "因 WinPay 升級了虛擬卡與實體卡服務，舊卡暫不支持使用 轉入 / 轉出功能。給您帶來的不便，敬請諒解。",
    "cardProcessingWait": "卡片处理中，请稍后再试",
    "cardBalance": "卡片余额",
    "accountBalance": "资金账户余额",
    "availableBalanceLabel": "可用餘額：",
    "rechargeCurrencyTitle": "充值幣種",
    "rechargeAmountTitle": "充值金額",
    "supportedConsumptionScenes": "支援消費場景",
    "keySupportedPlatforms": "重點支援平台",
    "allSupportedPlatforms": "全部支援平台",
    "otherServices": "其他服务",
    "otherPlatforms": "其他服務",
    "cardUsageRules": "用卡規範",
    "usageRule1": "退款率、撤銷率、失敗率、驗證率過高有凍卡風險",
    "usageRule2": "禁止在 Steam、Blizzard、EA、戰網、OYSTER LABS 等平台使用",
    "usageRule3": "禁止綁定訂閱平台自動扣費",
    "cardSafetyTips": "用卡安全提示",
    "cardSafetyTip1": "請勿將您的卡號、有效期限、CVV 等資料隨意告知他人",
    "cardSafetyTip2": "請您合法的使用預付卡，且僅在本卡合規範圍內使用",
    "unbindCard": "解除綁定卡片",
    "unBindCardText_1": "解除綁定卡片前，請留意卡內餘額：",
    "unBindCardText_2": "若卡內存有資金，解除綁定後餘額將自動退回至您的帳戶資產，預計 1-7 個工作日到帳。退款明細可於資金流水中查詢，如有疑問，歡迎聯絡官方客服。",
    "unBindCardText_3": "解除綁定後將產生以下影響",
    "unBindCardText_4": "該卡片將無法再用於支付及相關交易",
    "unBindCardText_5": "與該卡片綁定的自動扣費服務可能會受到影響",
    "unBindCardText_6": "解除綁定後將無法再次綁定該卡片",
    "unBindCardText_7": "解除綁定處理中",
    "unBindCardText_8": "正在解除綁定卡片...",
    "unBindCardText_9": "請稍候，預計需要兩分鐘",
    "unBindCardText_10": "為保護您的資金安全，解除綁定後將無法恢復",
    "unBindCardText_11": "解除綁定成功",
    "unBindCardText_12": "卡片解除綁定成功",
    "unBindCardText_13": "您的卡片已成功解除綁定，將不再顯示於卡片列表中",
    "unBindCardText_14": "解除綁定失敗",
    "unBindCardText_15": "卡片解除綁定失敗",
    "unBindCardText_16": "目前卡片解除綁定失敗，請稍後再試。如有疑問，請聯絡客服處理。",
    "unBindCardText_17": "已解除綁定卡片",
    "unBindCardText_18": "已解除綁定",
    "unBindCardText_19": "已解除綁定卡片詳情",
    "unBindCardText_20": "解除綁定卡片時的剩餘金額：",
    "unBindCardText_21": "剩餘金額退款是否成功：",
    "unBindCardText_22": "解除綁定卡片時間：",
    "unbindCardStatus": "卡片狀態",
    "unbindRefundYes": "是",
    "unbindRefundPending": "處理中",
    "minAmount": "最小金额",
    "exchangeRate": "當前價格",
    "chargeArrivalTitle": "充值到帳",
    "expectedCardArrival": "預計到帳",
    "expectedAccountArrival": "提現到賬",
    "submitTransfer": "確認",
    "transferSuccess": "划转成功",
    "transferSuccessTitle": "提示",
    "transferInSuccessDesc": "恭喜您，您已成功充值",
    "transferOutSuccessDesc": "恭喜您，您已成功提現",
    "enterChargeAmount": "請輸入充值金額",
    "enterTransferInAmount": "请输入转入数量",
    "enterTransferOutAmount": "请输入转出数量",
    "enterValidAmount": "请输入正确数量",
    "tradeDetail": "詳情",
    "tradeProcessingTip": "交易正在处理中，请稍后查看最终状态",
    "cardNumber": "卡號",
    "tradeType": "交易類型",
    "tradeDescription": "備註",
    "merchant": "商家",
    "amount": "金額",
    "tradeAmount": "交易金額",
    "orderNumber": "訂單編號",
    "orderId": "订单号",
    "tradeTime": "時間",
    "noTradeDetail": "暂无交易详情",
    "cvvTip": "CVV 码是卡片背面的 3 位或 4 位数字，用于验证您的身份",
    "sensitiveInfoLocked": "查看卡号、有效期和 CVV 前，需要先验证钱包密码。",
    "sensitiveInfoLockedDesc": "为保障账户安全，敏感卡片信息默认隐藏，验证通过后才会显示。",
    "unlockNow": "验证后查看",
    "myCard": "我的卡片",
    "basicInfo": "卡基本資訊",
    "cardType": "卡片類型",
    "cardholder": "持卡人",
    "phoneNumberLabel": "手機號",
    "validThru": "有效期（月/年）",
    "validThroughLabel": "有效期",
    "cvvCode": "CVV 码",
    "openSecurePage": "在新窗口打开安全页",
    "openVerificationPage": "打开验证页面",
    "checkVerificationStatus": "检查验证状态",
    "verificationPageUnavailable": "暂未获取到验证页面，请稍后检查状态",
    "diditSdkTitle": "Didit 人脸认证",
    "sdkIdle": "待启动",
    "sdkLoading": "认证加载中",
    "sdkReady": "认证进行中",
    "sdkUnavailable": "Didit SDK 加载失败，请改用外部打开",
    "sdkCancelled": "KYC 认证已取消",
    "sdkDeclined": "KYC 认证未通过",
    "restartVerification": "重新开始认证",
    "sdkCurrentStep": "当前步骤",
    "sdkLastEvent": "最近事件",
    "sdkStepDocumentSelection": "选择证件类型",
    "sdkStepDocumentFront": "拍摄证件正面",
    "sdkStepDocumentBack": "拍摄证件反面",
    "sdkStepFace": "人脸活体认证",
    "sdkStepEmail": "邮箱验证",
    "cameraPermissionTitle": "开启相机权限",
    "cameraPermissionTip": "后续证件拍摄和人脸识别需要使用浏览器相机，请先授权相机权限。",
    "cameraPermissionDenied": "当前浏览器未获得相机权限，请在浏览器设置中允许相机访问后再继续认证。",
    "cameraPermissionGranted": "浏览器相机权限已准备就绪，可以继续进行证件拍摄和人脸识别。",
    "cameraPermissionGrantedToast": "相机权限已开启",
    "cameraPermissionOpen": "开启权限",
    "cameraPermissionReady": "已开启",
    "cameraPermissionDialog": "当前未获得浏览器相机权限。请在浏览器地址栏或系统设置中允许相机访问后，再继续进行 KYC 认证。",
    "sdkStepPhone": "手机验证",
    "sdkStepPoa": "地址证明",
    "sdkStepQuestionnaire": "问卷信息",
    "sdkEventReady": "认证页已就绪",
    "sdkEventStarted": "已开始认证",
    "sdkEventStepStarted": "步骤开始",
    "sdkEventStepCompleted": "步骤完成",
    "sdkEventStepChanged": "步骤切换",
    "sdkEventMediaStarted": "已开启拍摄",
    "sdkEventMediaCaptured": "已完成拍摄",
    "sdkEventDocumentSelected": "已选择证件",
    "sdkEventSubmitted": "资料已提交",
    "sdkEventCodeSent": "验证码已发送",
    "sdkEventCodeVerified": "验证码已通过",
    "sdkEventStatusUpdated": "认证状态更新",
    "sdkEventCompleted": "认证流程完成",
    "sdkEventCancelled": "认证已取消",
    "sdkEventError": "认证发生错误",
    "sdkEventCloseRequest": "用户请求关闭",
    "kycTokenEmpty": "KYC token 为空，请稍后重试",
    "viewAtmPassword": "查看 ATM 密码",
    "enterAtmPassword": "请输入 6 位 ATM 密码",
    "confirmAtmPassword": "確認 ATM 密碼",
    "atmPasswordTip": "*此密碼只能設定一次，之後不可修改，可隨時查看。",
    "sixDigitPin": "请输入 6 位纯数字密码",
    "setPinSuccess": "密碼設定成功"
  },
  "mine": {
    "title": "我的",
    "mineCode": "我的二維碼",
    "scanAddFriend": "扫码添加我的WinPay Wallet好友吧",
    "wallet": "錢包管理",
    "cardCodeRedemption": "卡密核銷",
    "enterCardCode": "輸入卡密",
    "security": "安全設置",
    "language": "切換語言",
    "selectLanguage": "選擇語言",
    "contactUs": "聯絡我們",
    "about": "關於我們",
    "kyc": "KYC 認證",
    "userId": "我的用户 ID",
    "login": "登录/注册",
    "logout": "登出",
    "logoutConfirm": "确认退出当前账号吗？",
    "logoutConfirmTitle": "確認登出？",
    "logoutConfirmAccount": "確認登出目前帳戶【{name}】嗎？",
    "points": "積分",
    "currentLevel": "當前等級",
    "totalPoints": "總積分",
    "nextLevelPoints": "距下一等级还需 {points} 积分",
    "levelSurpassed": "已超过当前等级",
    "maxLevelReached": "已达到最高等级",
    "exclusiveLevel": "專屬等級",
    "dailyCheckInPoints": "每日簽到即可獲得積分",
    "rewardDetails": "獎勵明細",
    "signIn": "簽到",
    "signedIn": "已簽到",
    "checkInSuccess": "签到成功，奖励 {reward} 积分",
    "gameZone": "遊戲區",
    "gameDesc": "輕鬆賺積分",
    "shopZone": "電商區",
    "shopDesc": "下單送積分",
    "enterZone": "进入",
    "inviteFriends": "邀請好友",
    "inviteDesc": "邀请好友一起使用 WinPay",
    "invitedUsers": "邀请好友注册钱包总数",
    "recommender": "推荐人",
    "bindSuccess": "綁定成功",
    "takePhoto": "拍照",
    "chooseFromAlbum": "从相册选择",
    "avatarUpdated": "头像已更新",
    "avatarUploadFailed": "头像上传失败，请稍后重试",
    "avatarImageOnly": "请选择图片文件",
    "avatarImageTooLarge": "图片不能超过 {size}MB",
    "changeWalletName": "修改钱包名称",
    "enterWalletName": "請輸入錢包名稱",
    "nameTooLong": "名称不能超过 16 个字符",
    "nameUpdated": "名称已更新",
    "securityTodo": "安全设置迁移中",
    "kycTodo": "去认证",
    "kycPending": "审核中",
    "kycVerified": "已认证",
    "kycFailed": "认证失败",
    "kycTodoDesc": "完成 KYC 認證後，可繼續使用虛擬卡和實體卡相關能力。",
    "kycPendingDesc": "认证资料已提交，审核完成后即可继续后续操作。",
    "kycVerifiedDesc": "KYC 認證已完成，當前帳戶可以正常使用卡片實名認證能力。",
    "kycFailedDesc": "认证资料审核未通过，请根据失败原因重新提交。",
    "viewKycResult": "查看认证结果",
    "retryKyc": "重新认证",
    "aboutDesc": "一站式 Web3 支付钱包",
    "version": "版本",
    "contactDesc": "如有任何问题（例如删除钱包、使用问题等），欢迎通过以下方式联系我们：",
    "supportEmail": "客服信箱",
    "onlineSupport": "在線客服",
    "serviceMailbox": "客户服务邮箱",
    "serviceHours": "客户服务营业时间",
    "weekdayHours": "工作日: 上午09:00 - 下午18:00",
    "supportReplyTip": "本公司客服團隊將於營業時間內盡快回覆您，協助解決相關問題。",
    "supportThanks": "感谢您的支持与理解。"
  },
  "article": {
    "square": "廣場",
    "followTab": "關注",
    "likeTab": "讚",
    "nowTab": "即時",
    "create": "發布",
    "myArticle": "我的文章",
    "detail": "文章详情",
    "addToken": "添加 Token",
    "addNft": "添加 NFT",
    "reportTitle": "举报",
    "reportSuccess": "感谢您的反馈,将减少类似内容展示",
    "reportFailed": "提交失败，请稍后重试",
    "reasonAttack": "攻擊引戰",
    "reasonPorn": "色情低俗",
    "reasonDiscomfort": "引人不適",
    "reasonSpam": "垃圾廣告",
    "follow": "關注",
    "followed": "已關注",
    "followSuccess": "关注成功",
    "unfollowSuccess": "已取消关注",
    "likeSuccess": "点赞成功",
    "unlikeSuccess": "取消点赞",
    "now": "剛剛",
    "minutesAgo": "分鐘前",
    "hoursAgo": "小時前",
    "daysAgo": "天前",
    "views": "浏览",
    "forwarded": "轉發",
    "empty": "暂无内容",
    "searchPlaceholder": "搜索",
    "unsupportedNetwork": "当前网络暂不支持访问首页内容",
    "switchNetwork": "切換網絡",
    "observerWalletWarn": "观察钱包不能访问首页内容",
    "switchWallet": "切换钱包",
    "openDetailTodo": "文章详情待迁移",
    "createTodo": "发布文章待迁移",
    "addTokenTodo": "添加 Token 功能待迁移",
    "addNftTodo": "添加 NFT 功能待迁移",
    "sampleName": "WinPay 用户",
    "sampleTopic": "Flutter 文章模块迁移预览",
    "sampleContent": "这个页面用于承接文章模块迁移后的 H5 样式、状态和弹窗交互。"
  }
};
